<div class="px-gutter py-gutter" @stagger>
  <div @fadeInUp class="mb-6 flex flex-wrap items-center justify-between gap-4">
    <div class="flex items-center gap-4">
      <mat-icon class="cursor-pointer" color="primary" (click)="backToList()">arrow_back</mat-icon>
      <div>
        <h1 class="headline m-0 flex flex-wrap items-center gap-2">
          {{ team?.name ?? 'Équipe introuvable' }}
          <team-action-mock-team *ngIf="team" [team]="team"></team-action-mock-team>
        </h1>
        <p class="m-0 caption text-secondary">Maquette : données fictives</p>
      </div>
    </div>
    <team-action-mock-new-toggle></team-action-mock-new-toggle>
  </div>
  <team-action-mock-team-details-screen *ngIf="team" @fadeInUp [team]="team"></team-action-mock-team-details-screen>
</div>
